<template>
  <label
    :for="id"
    class="group/toggle relative flex w-fit items-center gap-x-2.5 cursor-pointer"
    @click.stop
  >
    <input type="checkbox" :id="id" v-model="model" class="sr-only peer" />
    <span
      :class="
        model
          ? 'from-green-200 to-green-200 border-green-300/70 shadow-inset-green'
          : 'from-gray-150 to-gray-100 border-gray-300/50 shadow-inset'
      "
      class="relative bg-gradient-to-r inline-flex rounded-full p-[0.125rem] pr-[1.5rem] border outline outline-transparent outline-2 outline-offset-2 peer-focus-visible:outline-blue-400 shrink-0 cursor-pointer transition-colors duration-200 ease-in-out peer-focus-visible:ring-2 peer-focus-visible:ring-blue-400 peer-focus-visible:ring-offset-2"
    >
      <span
        aria-hidden="true"
        :class="model ? 'border-green-100/70  translate-x-[1.375rem]' : 'border-gray-100'"
        class="w-7 h-7 flex items-center justify-center bg-white shadow-btn-white pointer-events-none transform rounded-full ring-0 transition duration-200 ease-out border"
      >
        <s-icon
          :name="model ? 'check-bold' : 'close-thick'"
          class="transition-colors"
          :class="model ? 'text-green-600' : 'text-gray-500/80'"
          size="16"
        />
      </span>
    </span>
    <span
      class="select-none cursor-pointer font-bold text-gray-700 leading-tight"
      :class="
        model ? 'text-green-600 hover:text-green-500' : 'text-gray-600/60 hover:text-blue-500'
      "
    >
      {{ model ? t('status.enabled') : t('status.disabled') }}
    </span>
  </label>
</template>

<script lang="ts" setup>
import {defineProps} from 'vue';
import SIcon from './SIcon.vue';
import {useI18n} from 'vue-i18n';

defineProps({
  id: {
    type: String,
    required: false,
  },
});

const model = defineModel<boolean>({default: false});

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});
</script>
